/**
 * @constant BsUtilEmptyMarket Constant for empty market
 */
export const BsUtilEmptyMarket = {
    eventId: "0",
    leagueId: "0",
    isLive: false
};
//# sourceMappingURL=BsUtilEmptyMarket.js.map